import { render, staticRenderFns } from "./packageEditDialog.vue?vue&type=template&id=96f3e5b0&scoped=true&"
import script from "./packageEditDialog.vue?vue&type=script&lang=js&"
export * from "./packageEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./packageEditDialog.vue?vue&type=style&index=0&id=96f3e5b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f3e5b0",
  null
  
)

export default component.exports